enum ManagerRole {
  BRIDGE_STAFF = 'bridge_staff',
  EXTERNAL = 'external',
}

export { ManagerRole };
